<div class="cell auto" *ngIf="parameters">
    <kiwi-parameters-tab-content-header
        [saveDisabled]="areParametersReadonly()"
        (saved)="updateParameters()"
        [titleLabelKey]="'parameters.quality.staff.title'">
    </kiwi-parameters-tab-content-header>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <p [i18nKey]="'parameters.quality.staff.description'"></p>

    <p [i18nKey]="'parameters.quality.staff.covers.number.description'"></p>

    <kiwi-spacer [size]="8"></kiwi-spacer>

    <table class="_tableColor">
        <tbody>
        <tr>
            <td [i18nKey]="'parameters.quality.staff.covers.number'"></td>
            <td>
                <input type="number" step="1" [(ngModel)]="parameters.standardCoversNumber"
                       [disabled]="areParametersReadonly()"/>
            </td>
        </tr>
        </tbody>
    </table>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <h2 class="_sansSerif _primary"[i18nKey]="'parameters.quality.staff.standard.wages.bill.title'"></h2>

    <table class="_tableColor">
        <thead>
        <tr class="_titlePartTable">
            <th [i18nKey]="'common.restaurant'"></th>
            <th style="text-align:center"[i18nKey]="'parameters.quality.staff.quality.25'"></th>
            <th style="text-align:center"[i18nKey]="'parameters.quality.staff.quality.50'"></th>
            <th style="text-align:center"[i18nKey]="'parameters.quality.staff.quality.80'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td [i18nKey]="'parameters.quality.staff.cooking'"></td>
            <td>
                <kiwi-currency-input [(ngModel)]="parameters.standardCookWageBillQuality25"
                                     [disabled]="areParametersReadonly()"></kiwi-currency-input>
            </td>
            <td>
                <kiwi-currency-input [(ngModel)]="parameters.standardCookWageBillQuality50"
                                     [disabled]="areParametersReadonly()"></kiwi-currency-input>
            </td>
            <td>
                <kiwi-currency-input [(ngModel)]="parameters.standardCookWageBillQuality80"
                                     [disabled]="areParametersReadonly()"></kiwi-currency-input>
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'parameters.quality.staff.customer.care'"></td>
            <td>
                <kiwi-currency-input [(ngModel)]="parameters.standardWaiterWageBillQuality25"
                                     [disabled]="areParametersReadonly()"></kiwi-currency-input>
            </td>
            <td>
                <kiwi-currency-input [(ngModel)]="parameters.standardWaiterWageBillQuality50"
                                     [disabled]="areParametersReadonly()"></kiwi-currency-input>
            </td>
            <td>
                <kiwi-currency-input [(ngModel)]="parameters.standardWaiterWageBillQuality80"
                                     [disabled]="areParametersReadonly()"></kiwi-currency-input>
            </td>
        </tr>
        </tbody>
    </table>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <h2 class="_sansSerif _primary"[i18nKey]="'parameters.quality.staff.maximal.production.quality.title'"></h2>

    <p [i18nKey]="'parameters.quality.staff.maximal.production.quality.description'"></p>

    <table class="_tableColor">
        <thead>
        <tr class="_titlePartTable">
            <th [i18nKey]="'common.restaurant'"></th>
            <th style="text-align:center"[i18nKey]="'parameters.quality.staff.quality.25'"></th>
            <th style="text-align:center"[i18nKey]="'parameters.quality.staff.quality.50'"></th>
            <th style="text-align:center"[i18nKey]="'parameters.quality.staff.quality.80'"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td [i18nKey]="'parameters.quality.staff.cooking'"></td>
            <td>
                <input type="number" [(ngModel)]="parameters.maximalCookingStaffQualityType1Restaurant" disabled/>
            </td>
            <td>
                <input type="number" [(ngModel)]="parameters.maximalCookingStaffQualityType2Restaurant" disabled/>
            </td>
            <td>
                <input type="number" [(ngModel)]="parameters.maximalCookingStaffQualityType3Restaurant" disabled/>
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'parameters.quality.staff.customer.care'"></td>
            <td>
                <input type="number" [(ngModel)]="parameters.maximalCustomerCareStaffQualityType1Restaurant" disabled/>
            </td>
            <td>
                <input type="number" [(ngModel)]="parameters.maximalCustomerCareStaffQualityType2Restaurant" disabled/>
            </td>
            <td>
                <input type="number" [(ngModel)]="parameters.maximalCustomerCareStaffQualityType3Restaurant" disabled/>
            </td>
        </tr>
        </tbody>
    </table>
</div>
